import { render, staticRenderFns } from "./TagsAdicionais.vue?vue&type=template&id=51a95210&scoped=true&"
import script from "./TagsAdicionais.vue?vue&type=script&lang=js&"
export * from "./TagsAdicionais.vue?vue&type=script&lang=js&"
import style0 from "./TagsAdicionais.vue?vue&type=style&index=0&id=51a95210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a95210",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
